import { Heading as BlazeHeading } from 'blaze-ui/Heading/Heading'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { FacebookNotice } from 'components/IntegrationInitialization/FacebookInitialization/FacebookInitialization'
import { InstagramNotice } from 'components/IntegrationInitialization/InstagramInitialization/InstagramInitialization'
import { ConnectProviderPanelProps } from 'screens/BrandKit/LinkedAccountsDrawer/Types'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { Button } from 'blaze-ui/Button'
import { ArrowUpRightSquareContained } from 'blaze-ui/icons'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import Styles from './ConnectProviderPanel.module.scss'
import { LinkedInNotice } from 'components/IntegrationInitialization/LinkedinInitialization/LinkedinInitialization'
import { useMemo } from 'react'

const Notice = ({ provider }: ConnectProviderPanelProps) => {
  if (provider === ExternalIntegrationEnum.Facebook) {
    return <FacebookNotice />
  }

  if (provider === ExternalIntegrationEnum.LinkedIn) {
    return <LinkedInNotice />
  }

  return <InstagramNotice />
}

const Heading = ({ provider }: ConnectProviderPanelProps) => {
  if (provider === ExternalIntegrationEnum.LinkedIn) {
    return <BlazeHeading level={2}>We’re sending you to LinkedIn to link your account to Blaze.</BlazeHeading>
  }

  return <BlazeHeading level={2}>We’re sending you to Facebook to link your account to Blaze.</BlazeHeading>
}

export const ConnectProviderPanel = ({ provider, ...connectProps }: ConnectProviderPanelProps) => {
  const { connect } = useConnectAccountPopup()
  const { initiateOauth } = useInitiateOauth()

  const handleConfirm = async () => {
    const popup = await initiateOauth(provider, undefined, '_blank', 'popup=true,width=600,height=780')
    popup && connect(popup, connectProps)
  }

  const buttonLabel = useMemo(() => {
    if (provider === ExternalIntegrationEnum.LinkedIn) {
      return 'Go to Connect LinkedIn'
    }

    if (provider === ExternalIntegrationEnum.Instagram) {
      return 'Go to Connect Instagram Business'
    }

    return 'Go to Connect Facebook Business'
  }, [provider])

  return (
    <div className={Styles.root}>
      <Heading provider={provider} />
      <Notice provider={provider} />
      <Button
        fullWidth
        size="lg"
        endIcon={ArrowUpRightSquareContained}
        onPress={() => handleConfirm()}
        aria-label={buttonLabel}
      >
        {buttonLabel}
      </Button>
    </div>
  )
}
